import React from 'react';

import { getVisibleRoofPlanes } from '../../../../store/selectors/layoutDataSelectors';
import { useAppSelector } from '../../../hooks';
import { AutoCutPlanesMenuItemButton } from '../../../interface/subpanels/properties/roof-planes/AutoCutPlanesButtons';
import { SceneMenuContent } from '../common/SceneMenuContent';
import { AddItemMenuItem } from '../shared-menu-items/AddItemMenuItem';

export function RoofPlanesContainerMenu() {
  const roofPlanes = useAppSelector(getVisibleRoofPlanes);
  return (
    <SceneMenuContent>
      <AddItemMenuItem type="roofPlane" />

      <AutoCutPlanesMenuItemButton
        roofPlaneGuids={roofPlanes.map(({ guid }) => guid)}
        monitorSource="Roof Plane Container"
      />
    </SceneMenuContent>
  );
}
